export const form = {
    username: {
        example: {
            label: 'Exemple de nom d\'utilisateur',
            content: 'Michel D.'
        },
        reset: "Effacer le nom d'utilisateur",
        delete: 'Supprimer ce compte local',
        label: "Nom d'utilisateur (entre 3 et 64 caractères)",
        error: 'Merci de saisir un nom d\'utilisateur valide (ex: {usernameExample})',
        rules: {
            btnLabel: 'Afficher les règles des champs de type "nom d\'utilisateur"',
            label: 'Règles du nom d\'utilisateur',
            desc:  `
            Le nom d'utilisateur doit contenir de {usernameMin} à {usernameMax} caractères.
            `
        }
    },
    email: {
        example: {
            label: 'Exemple d\'identifiant',
            content: "prenom.nom{'@'}domaine.fr"
        },
        reset: "Effacer l'identifiant",
        delete: 'Supprimer ce compte local',
        select: {
            label: '* Identifiant (email)',
        },
        label: 'Identifiant (email)',
        error: 'Merci de saisir une adresse email valide (ex: {emailExample})',
        rules: {
            btnLabel: 'Afficher les règles des champs de type "identifiant"',
            label: 'Règles de l\'identifiant',
            desc:  `
            L'identifiant doit être une adresse mail valide.
            `
        },
        btnOtherAccount: 'Se connecter avec un autre compte',
        btnNewAccount: 'Se connecter avec un compte existant',
        btnRemoveAccount: 'Supprimer ce compte',
    },
    password: {
        example: {
            label: 'Exemple de mot de passe',
            content: 'Azerty!1234'
        },
        normal: {
            label: 'Mot de passe',
            show: 'Afficher le mot de passe',
            hide: 'Masquer le mot de passe',
            reset: 'Effacer le mot de passe',
        },
        current: {
            label: 'Mot de passe actuel',
            show: 'Afficher le mot de passe actuel',
            hide: 'Masquer le mot de passe actuel',
            reset: 'Effacer le mot de passe actuel',
        },
        new: {
            label: 'Nouveau mot de passe' ,
            show: 'Afficher le nouveau mot de passe',
            hide: 'Masquer le nouveau mot de passe',
            reset: 'Effacer le nouveau mot de passe',
        },
        confirmation: {
            label: 'Confirmation du mot de passe',
            show: 'Afficher le mot de passe de confirmation',
            hide: 'Masquer le mot de passe de confirmation',
            reset: 'Effacer le mot de passe de confirmation',
        },
        wrong: 'Mot de passe erronné',
        security: 'Le mot de passe doit suivre les règles de sécurité.',
        error: 'Merci de saisir un mot de passe valide (ex: {passwordExample})',
        securityLevelLabel: 'Robustesse du mot de passe :',
        rules: {
            btnLabel: 'Afficher les règles des champs de type "mot de passe"',
            label: 'Règles du mot de passe',
            desc:  `
            Le mot de passe doit contenir entre {passwordMin} et {passwordMax} caractères, dont: au moins une lettre majuscule, au moins une lettre minuscule,
            au moins un chiffre, au moins un caractère spécial: {passwordAuthCar}
            `
        }
    },
    textarea: {
        example: {
            label: 'Exemple de message',
            content: 'Bonjour'
        },
        reset: "Effacer le contenu du message",
        label: 'Message à adresser à l\'équipe ({messageMin} caractères minimum)',
        error: 'Merci de saisir un message d\'au moins {messageMin} caractères (exemple: {messageExample})',
        rules: {
            btnLabel: 'Afficher les règles des champs de type "message"',
            label: 'Règles du message',
            desc: `
            Le message doit contenir minimum {messageMin} caractères.
            `
        }
    },
    subject: {
        error: 'Merci de sélectionner l\'objet de votre message (exemple: Autre sujet)'
    }
}